export const calculateClassLengths = (pipeSpecs = [], pipeODQuantity, pipePricing = [], coatingPricing = []) => {
  const pipeOD = parseFloat(pipeODQuantity);
  const matched = pipePricing.find((item) => parseFloat(item.pipeOD) === pipeOD);
  const pricePerTon = matched?.pricePerTon ?? 0;

  const getLength = (index) => {
    const baseQty = parseFloat(pipeSpecs[index]?.baseQty) || 0;
    const percentOverBuy = (parseFloat(pipeSpecs[index]?.percentOverBuy) || 0) / 100;
    return Math.round(baseQty * (1 + percentOverBuy));
  };

  const getPricePerFoot = (index) => {
    const lbsPerFt = parseFloat(pipeSpecs?.[index]?.lbsPerFt) || 0;
    const lbsPerTon = lbsPerFt / 2000;
    return parseFloat((lbsPerTon * pricePerTon).toFixed(2));
  };

  const getCost = (index, length) => {
    const internalCoating = pipeSpecs?.[index]?.internalCoating;
    const lbsPerFt = parseFloat(pipeSpecs?.[index]?.lbsPerFt) || 0;
    const lbsPerTon = lbsPerFt / 2000;
    const pricePerFoot = parseFloat((lbsPerTon * pricePerTon).toFixed(2));

    const matchedCoating = coatingPricing.find((item) => parseFloat(item.pipeOD) === pipeOD);

    const aroPricePerFoot = matchedCoating?.aroPricePerFoot ?? 0;

    return internalCoating === 'Yes'
      ? parseFloat(((pricePerFoot + aroPricePerFoot) * length).toFixed(2))
      : parseFloat(((pricePerFoot + 0) * length).toFixed(2));
  };

  const pipeClasses = [
    'Class 1',
    'Class 2',
    'Class 3',
    'Class 4',
    'Bore Pipe Class 1',
    'Bore Pipe Class 2',
    'Bore Pipe Class 3',
    'Direct Pipe',
    'HDD',
  ];

  return pipeClasses.map((className, index) => {
    const length = getLength(index);
    return {
      no: index + 1,
      class: className,
      length,
      pricePerFoot: getPricePerFoot(index),
      cost: getCost(index, length),
    };
  });
};
